<div
  class="chart-legend"
  *ngIf="energyHistoricalDataStore.legendFeatures$ | async as legendFeatures"
>
  <div data-at-legend-item class="legend-item" *ngFor="let entry of legendFeatures">
    <span [style.background-color]="entry.color" class="legend-item-indicator"></span>
    {{ entry.feature }}
  </div>
</div>
